import { Component, Input } from '@angular/core'
import { isNumber, sumBy } from 'lodash'

const COLORS = [
  ['#7d5bf3', '#e3dff8'],
  ['#ed44b0', '#fde8f5'],
  ['#5cddb0', '#e0faf1'],
]

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent {
  @Input() text: string
  @Input() size = 50
  @Input() border: boolean | number = false
  @Input() borderColor: string
  @Input() backgroundColor: string

  get symbol() {
    return this.text && this.text.toString()[0].toUpperCase()
  }

  get textSize() {
    return Math.round(this.size * 0.35)
  }

  get borderWidth() {
    if (isNumber(this.border)) return this.border

    return !this.border ? 0 : 1
  }

  get color() {
    const value = sumBy(this.text, (c) => c.charCodeAt(0))

    const colors = COLORS[value % COLORS.length]
    return [this.borderColor || colors[0], this.backgroundColor || colors[1]]
  }
}
